import { inject } from '@angular/core';
import { type ActivatedRouteSnapshot, type ResolveFn, type RouterStateSnapshot } from '@angular/router';
import { AppService } from '@core';
import { Store } from '@ngrx/store';

import { ClientUsersActions } from './client-users.actions';

export const clientUsersResolver: ResolveFn<void> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const clientId = route.queryParams['clientId'] || inject(AppService).currentClient;

  return inject(Store).dispatch(ClientUsersActions.loadClientUsers({ clientId }));
};
